import React from 'react'
import withQueryParams from 'components/withQueryParams'
import { Route } from 'react-router-dom'
import RouteSignUpIndex from './sign-up/index'
import AppLogoLink from 'components/AppLogoLink'
import styled from '@emotion/styled'

const Main = styled.main`
  display: flex;
  min-height: 100vh;
  width: 100%;
  justify-content: center;
  align-items: center;
`

const Container = styled.div`
  width: 30%;
  padding: 70px 0px;

  @media only screen and (max-width: 820px) {
    width: 50%;
  }

  @media only screen and (max-width: 620px) {
    width: 75%;
  }

  @media only screen and (max-width: 450px) {
    width: 90%;
  }
`

const RouteSignUp = ({ match: { path }, query }) => (
  <React.Fragment>
    <Main>
      <Container>
        <AppLogoLink clientId={query.get('client_id')} />
        <Route path={path} exact component={RouteSignUpIndex} />
      </Container>
    </Main>
  </React.Fragment>
)

export default withQueryParams(RouteSignUp)



// WEBPACK FOOTER //
// ./src/routes/sign-up.js